export const quickFilters = {
    onChangeQuickFilters: (store, payload) => {
      store.setState({ quickFilters: payload });
    },
  };
  